<template>
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">

        <div class="table__label table__label--small">
          {{ $t(`offersTable.${"startDate"}`) }}
        </div>
        <div class="table__label table__label--medium">
          {{ $t(`offersTable.${"type"}`) }}
        </div>
        <div class="table__label table__label--small">
          {{ $t(`offersTable.${"status"}`) }}
        </div>
        <div class="table__label table__label--medium">
          {{ $t(`offersTable.${"agent"}`) }}
        </div>
        <div class="table__label table__label--medium">
          {{ $t(`offersTable.${"assignedTo"}`) }}
        </div>
        <div class="table__label table__label--medium">
          {{ $t(`offersTable.${"sentDate"}`) }}
        </div>
        <div class="table__label table__label--smaller">
          {{ $t(`offersTable.${"file"}`) }}
        </div>
        <div class="table__label table__label--small table__label--last"></div>
      </div>

      <div class="table__body">
        <Loading v-if="detailsLoading" />
        <template v-else>
          <div v-if="!customerOffers.length" class="table__no-data">
            <NoData :type="'offers'" />
          </div>
          <template v-else>
            <Offer v-for="(offer, index) in customerOffers" :key="offer.id" :offer="offer" :index="index" />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import NoData from "@/partials/NoData";
import Loading from "@/partials/Loading";
import Offer from "@/components/AccountDetails/Offer";

defineOptions({
  name: "OffersTable"
});

const store = useStore();

// State
const detailsLoading = ref(false);
const lastFetchedCustomerId = ref(null);

// Computed
const customerOffers = computed(() => store.getters.customerOffers);
// const customerDetails = computed(() => store.getters.customerDetails);
const costumerId = computed(() => store.getters.customerDetailsId);

// Methods
const fetchOffers = async () => {
  if (!costumerId.value) return;

  detailsLoading.value = true;
  try {
    await store.dispatch("getCustomerOffers", costumerId.value);
    lastFetchedCustomerId.value = costumerId.value;
  } finally {
    detailsLoading.value = false;
  }
};

// Watchers
watch(costumerId, (newId) => {
  if (newId && lastFetchedCustomerId.value !== newId) {
    fetchOffers();
  }
});

// Lifecycle
onMounted(async () => {
  if (lastFetchedCustomerId.value === costumerId.value) {
    return;
  }

  if (costumerId.value) {
    await fetchOffers();
  }
});
</script>

<style scoped lang="scss">
.loading { 
  height: 76vh;  
}
</style>
